<template>
	<el-dialog
		:show-close="false"
		:close-on-click-modal="false"
		:visible="visible"
		@close="onCloseDialog"
		@open="onOpenDialog"
		width="960px">
		<span slot="title">{{ title }}</span>
		<el-row style="padding: 20px;">
			<el-col :span="12" style="border: 1px solid rgb(217, 217, 217);">
				<div class="header">全部产品</div>
				<div style="height: 525px;overflow-y: auto;">
					<el-input
					  placeholder="请输入"
					  v-model="filterText"
						size="mini"
						style="width: 345px;margin: 10px;"
						clearable
						@clear="clearInitialize"
						onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
						>
					</el-input>
					<el-button @click="inputBlur" size="mini">查 询</el-button>
					<div v-for="(item,index) in treeData" style="line-height: 24px;">
						<span @click="getPageBybmcid(item,index,1)" style="margin-left: 6px;cursor: pointer;">
							<i :class="item.elIcon"></i>
							{{item.productClassifyName}}
						</span>
						<el-button type="text" style="margin-left: 6px;" @click="allChange(index,item.childData,1)" v-if="item.childData.length != item.checkList.length && item.elIcon == 'el-icon-caret-bottom'">全选</el-button>
						<el-button type="text" @click="allChange(index,item.childData,2)" v-if="item.childData.length == item.checkList.length && item.elIcon == 'el-icon-caret-bottom'">取消全选</el-button>
						<el-checkbox-group v-model="item.checkList" v-for="i in item.childData" v-if="item.elIcon == 'el-icon-caret-bottom'" style="margin-left: 25px;line-height: 24px;">
							<el-checkbox :label="i.allProductName" @change="chooseAlone(i)"></el-checkbox>
						</el-checkbox-group>
						<div v-if="item.childData.length == 0 && item.elIcon == 'el-icon-caret-bottom'"
							style="color: rgb(204, 204, 204);margin-left: 24px;height: 30px;"
							v-loading="divLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
							暂无数据
						</div>
						<div>
							<el-button style="margin-left: 22px;" type="text" @click="addMore(index,item.childData,item.pageSize,item)" v-if="item.addMoreShow">更多</el-button>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="12" style="border: 1px solid rgb(217, 217, 217);">
				<div class="header">已选产品</div>
				<div style="height: 525px;overflow-y: auto;">
					<div v-for="(item,index) in selectedData" class="selSty">
						<el-tooltip class="item" effect="dark" :content="item.productInfo" placement="top" v-if="item.productInfo.length > 35">
							<div class="ellipsisFont">
								{{item.productInfo}}
							</div>
				    </el-tooltip>
						<div class="ellipsisFont" v-else>
							{{item.productInfo}}
						</div>

						<div style="float: right;">
							<i class="el-icon-circle-close" style="cursor: pointer;" @click="onDeleteProduct(index,item.smallName)"></i>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
		<span slot="footer">
			<el-button @click="onFinishProduct" size="small" class="g-confirm-btn">完成</el-button>
			<el-button @click="onFinishProduct" size="small" type="TheCustom">取消</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	productInfo: 'productDialog',

	// watch: {
  //   filterText(val) {
  //     this.$refs.tree.filter(val);
	// 	},
  // },

	props: {
		visible: {
			type: Boolean,
			default: false
		},
		products: {
			type: Array,
		},
		isInMyActivityPage: {
			type: Boolean,
			default: false
		},
		isNotInAddPage: {
			type: Boolean,
			default: false
		},
		data: {
			type: Array,
		},
		title: {
			type: String,
			default: '请选择活动产品'
		},
		selectData: {
			type: Array,
			default: () => []
		},
	},

	components:{},

	data () {
		return {
			hasSetKeysDataOnce: false,
			selectedData: [],
			selectKeysData: [],
			addFieldData: [],
			filterText: '',
			defaultProps: {
        value: 'id',
        label: 'productClassifyName'
      },
			// 重构树形组件
			treeLoading: true,
			fathData: [],
			page: 50000,
			divLoading: true,
			pageSize: 500,
			treeData: [],
		}
	},

	methods: {
		// 父组件触发子组件
		open(data) {
			for (let zz in data) {
				data[zz].elIcon = 'el-icon-caret-right'
				data[zz].childData = []
				data[zz].checkList = []
				data[zz].pageSize = 500
				data[zz].addMoreShow = false
			}
			this.pageSize = 500
			this.treeData = data
		},
		// 数据搜索
		inputBlur() {
			if (this.filterText == '') {
				this.clearInitialize()
			} else {
				let params = {
					page: this.page,
					productname: this.filterText,
					type: 'add'
				}
				fetch({
					url: "hcm/hcmProduct/getListBybmcid",
					method: "get",
					params: params,
					noFormat: true,
					responseType: "text"
				}).then(result => {
					let res = JSON.parse(result);
					let {data}=res
					if(res.status == '10000'){
						console.log(123123)
						this.treeData = []
						for (let zz in data) {
							data[zz].elIcon = 'el-icon-caret-bottom'
							data[zz].childData = []
							data[zz].checkList = []
							data[zz].pageSize = 500
							data[zz].addMoreShow = false
						}
						this.treeData = data
						let childData = []
						for (let a in data) {
							for (let b in data[a].children) {
								if (data[a].id == data[a].children[b].productClassifyId) {
									this.treeData[a].childData.push({
										id: data[a].children[b].id.split(',')[0],
										productClassifyNameAndProductName: data[a].children[b].id.split(',')[1],
										allProductName: data[a].children[b].productClassifyName,
										// disableShow: data[a].children[b].disableShow
									})
								}
								for (let c in this.selectedData) {
									if (data[a].children[b].productClassifyName == this.selectedData[c].smallName) {
										this.treeData[a].checkList.push(this.selectedData[c].smallName)
									}
								}
							}
						}
						this.$forceUpdate()
					} else {
						this.$message({
							message: res.message,
							type: "error"
						});
					}
				})
			}
		},
		// 点击事件
		chooseAlone(i) {
			let joinshow = true
			if (this.selectedData.length != 0) {
				for (let a in this.selectedData) {
					if (this.selectedData[a].productInfo === i.productClassifyNameAndProductName) {
						joinshow = false
						this.selectedData.splice(a,1)
					}
				}
			}
			if (joinshow) {
				this.selectedData.push({
					product_id: i.id,
					productInfo: i.productClassifyNameAndProductName,
					smallName: i.allProductName
				})
			}
			this.$forceUpdate()
		},
		// 全选
		allChange(index,childData,type) {
			console.log(type)
			console.log(childData)
			console.log(index)
			if (type == 1) {
				this.treeData[index].checkList = []
				for (let a in childData) {
					// if (childData[a].disableShow != true) {
						this.treeData[index].checkList.push(childData[a].allProductName)
					// }
				}
				if (this.treeData[index].checkList.length != 0) {
					this.handleCheckChange(this.treeData,index)
				}
			} else {
				// 反选
				if (this.treeData[index].checkList.length != 0) {
					this.treeData[index].checkList.forEach(val=>{
				    let index = this.selectedData.findIndex(item=>item.smallName === val)
				    if(index != -1){
			        this.selectedData.splice(index,1)
				    }
					})
					this.treeData[index].checkList = []
				}
			}
		},
		// 获取详细数据
		getPageBybmcid(item,index,num) {
			if (this.filterText && this.filterText != '') {
				// 搜索不需要调用接口
				if (item.elIcon == 'el-icon-caret-right') {
					this.treeData[index].elIcon = 'el-icon-caret-bottom'
				} else {
					this.treeData[index].elIcon = 'el-icon-caret-right'
				}
			} else {
				this.treeLoading = true
				this.divLoading = true
				if (num == 1) {
					if (item.elIcon == 'el-icon-caret-right') {
						this.treeData[index].elIcon = 'el-icon-caret-bottom'
					} else {
						this.treeData[index].elIcon = 'el-icon-caret-right'
						this.treeData[index].addMoreShow = false
					}
				}
				let params = {
					pageNo: 1,
					pageSize: this.pageSize,
					classifyid: item.id,
					type: 'tree'
				}
				fetch({
					url: "hcm/hcmProduct/getPageByTree",
					method: "get",
					params: params,
					noFormat: true,
					responseType: "text"
				}).then(result => {
					let res = JSON.parse(result);
					let {data}=res
					if(res.status == '10000'){
						this.treeData[index].childData = data.list
						for (let a in this.treeData[index].childData) {
							for (let b in this.selectedData) {
								if (this.treeData[index].childData[a].id == this.selectedData[b].product_id) {
									this.treeData[index].checkList.push(this.selectedData[b].smallName)
								}
							}
						}
						if (this.treeData[index].pageSize > data.total) {
							this.treeData[index].addMoreShow = false
						} else {
							this.treeData[index].addMoreShow = true
						}
						this.divLoading = false
						this.$forceUpdate()
					} else {
						this.$message({
							message: res.message,
							type: "error"
						});
					}
				})
			}
		},
		// 数据处理
		handleCheckChange(data,index) {
			 console.log(1231231231235645)
			if (data[index] && data[index].childData) {
				for (let a in data[index].childData) {
					// if (data[index].childData[a].disableShow != true) {
						this.selectedData.push({
							product_id: data[index].childData[a].id,
							productInfo: data[index].childData[a].productClassifyNameAndProductName,
							smallName: data[index].childData[a].allProductName
						})
					// }
				}
			}
			// 已选产品去重
			var kv = {}
			for (var i = 0; i < this.selectedData.length;) {
				if (kv[this.selectedData[i].productInfo + ',' + this.selectedData[i].product_id]) {
					this.selectedData.splice(i, 1)
				} else {
					kv[this.selectedData[i].productInfo + ',' + this.selectedData[i].product_id] = true
					i++
				}
			}
    },
		// 更多
		addMore(index,childData,pageSize,item){
			this.pageSize = pageSize + 500
			this.treeData[index].pageSize = this.pageSize
			this.getPageBybmcid(item,index,2)
		},
		// 删除初始化
		clearInitialize() {
			this.$emit('fatherBlur')
		},
		onDeleteProduct(index,smallName) {
				this.selectedData.splice(index,1)
				if (this.treeData.length != 0) {
					for (let c in this.treeData) {
						for (let d in this.treeData[c].checkList) {
							if (smallName == this.treeData[c].checkList[d]) {
								this.treeData[c].checkList.splice(d,1)
								this.$forceUpdate()
							}
						}
					}
				}
		},
		onFinishProduct() {
			console.log(this.data)
			this.$emit('on-finish-product', {
				key: this.selectKeysData,
				tree: this.selectedData,
				addFieldData: this.addFieldData,
			});
		},
		onCloseDialog() {
			this.$emit('on-close', {
				key: this.selectKeysData,
				tree: this.selectedData,
				addFieldData: this.addFieldData,
			});
		},
		onOpenDialog() {
			// console.log(this.selectKeysData)
			// 需要来个延迟，不然树状控件绑定的数据改变不了
			// if(!this.hasSetKeysDataOnce) {
			// 	if(this.isInMyActivityPage || this.isNotInAddPage) {
			// 		this.echoProduct()
			// 	}
			// 	setTimeout(() => {
			// 		this.$refs.tree.setCheckedKeys(this.selectKeysData);
			// 		if(this.isInMyActivityPage) {
			// 			this.$refs.tree.getCheckedNodes().forEach(item => {
			// 				if(typeof item.id === 'string') {
			// 					this.selectedData.push({
			// 						product_id: item.id.split(',')[0],
			// 						productInfo: item.id.split(',')[1],
			// 						productLink: item.pluginLink
			// 					})
			// 				}
			// 			})
			// 		}
			// 		this.hasSetKeysDataOnce = true;
			// 	}, 100);
			// }
		},
		// echoProduct() {
		// 	// 后端字段不一样，卒
		// 	this.products.forEach(product => {
		// 		this.selectKeysData.push(this.isInMyActivityPage ? `${product.product_id},${product.product_info}` : `${product.product_id},${product.productInfo}`)
		// 	})
		// },
		// 过滤节点
		// filterNode(value, data) {
		// 	if (!value) return true;
    //   return String(data.productClassifyName).indexOf(value) !== -1;
		// },
		// 处理树状控件改变
		// handleTreeChange() {
		// 	this.selectKeysData = [];
		// 	this.selectedData = [];
		// 	this.addFieldData = [];
		// 	this.$refs.tree.getCheckedNodes().forEach(item => {
		// 		if(typeof item.id === 'string') {
		// 			this.selectKeysData.push(item.id);
		// 			this.addFieldData.push(item.addField);
		// 			this.selectedData.push({
		// 				product_id: item.id.split(',')[0],
		// 				productInfo: item.id.split(',')[1],
		// 				productLink: item.pluginLink
		// 			})
		// 		}
		// 	})
		// },
		// 刷新已选,在activityMixin文件回调中使用
		// refleshChecked(data) {
		// 	console.log(data)
		// 	this.selectKeysData = data.key;
		// 	this.selectedData = data.tree;
		// 	this.addFieldData = data.addFieldData;
		// 	if(this.$refs.tree) {
		// 		this.$refs.tree.setCheckedKeys(data.key || []);
		// 	}
		// }
	},

	computed: {},


}
</script>

<style lang='scss' scoped>
@import "style/activityDeclaration.scss";
.product .el-dialog__body {
	height: 615px;
	overflow: auto;
	padding: 0;
}

.all-product-box {
	padding: 20px;
	border-right: 1px solid rgb(165, 165, 165);
}

.select-product-box {
	padding: 20px;
}

.product .el-tree-node__label {
	overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.select-info {
	display: flex;
	justify-content: space-between;
}

.product-delete-btn {
	color: gray;
	cursor: pointer;
}
.header{
	padding: 0 0 0 10px;
	line-height: 40px;
	margin: 0;
	background-color: #f6f7fb;
}
.selSty {
	padding: 0 11px;
	height: 32px;
	line-height: 32px;
}
.selSty:hover {
	background-color: #f6f7fb;
}
.ellipsisFont {
	float: left;
	width: 400px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	height: 32px;
	line-height: 32px;
}
.el-button--TheCustom {
	color: #666;
	border-color: #D9D9D9;
	background-color: #fff;
}
.el-button--TheCustom:hover  {
	color: #666;
	border-color: #ded2b8;
	background-color: #faf9f5;
}
</style>
